module.exports = __webpack_public_path__ + "img/official.3f3e859a.webp";